import { getMarkupMediaIdentity } from "@dialogueconsulting/sked-preview";
import type { PostMediaFile } from "shared/types/post";

// Mirror persisted annotation media identities. A form-local _id can differ
// from the asset identifier; the URL lets the review pane resolve legacy media.
export function getReviewMediaId(
  file:
    | (PostMediaFile & {
        hash?: string;
        media_id?: string;
        urn?: string;
      })
    | null
    | undefined
): string | undefined {
  return (
    file?.asset_id ||
    file?.hash ||
    file?.media_id ||
    file?.urn ||
    getMarkupMediaIdentity(file?.url || file?.thumbnailUrl)
  );
}
